
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import TextField from "../../../bootstrap/TextField/index.jsx";
import {
  ContactInputWrapper,
  ContactText,
  ContactWrapper,
  LoginText,
  LoginWrapper,
  Select,
  UserContactWrapper,
} from "./Contact.styles.js";

const Contact = ({
  setPassengerInformation,
  passengerInformation,
  values,
  setValues,
  handleChange,
  token,
}) => {
  const { webSettingData, languageData } = useSelector(
    (state) => state.busLists
  );

  const [countryName, setCountryName] = useState([]);
  const [userProfileInfo, setUserProfileInfo] = useState(null);
  const history = useHistory();

  const language = webSettingData?.language;
  const country = webSettingData?.country;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/countries`)
      .then((res) => res.json())
      .then((data) => setCountryName(data?.data || []))
      .catch((error) => console.error("Country loading failed:", error));
  }, []);

  useEffect(() => {
    try {
      setUserProfileInfo(
        JSON.parse(localStorage.getItem("userProfileInfo"))
      );
    } catch {
      setUserProfileInfo(null);
    }
  }, [passengerInformation, token]);

  useEffect(() => {
    const selectedCountry = countryName.find(
      (item) => item?.id == country
    );

    if (selectedCountry) {
      setValues((prev) => ({
        ...prev,
        mobile_country_code: selectedCountry.phonecode,
      }));
    }
  }, [countryName, country, setValues]);

  const handleLogin = () => {
    history.push({
      pathname: "/login",
      state: { update: true },
    });
  };

  const updatePassenger = (field, value) => {
    setPassengerInformation((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const selectedCountryCode =
    values?.mobile_country_code ||
    countryName.find((item) => item?.id == country)?.phonecode ||
    "";

  return (
    <>
      {!userProfileInfo && (
        <LoginWrapper>
          <strong>
            {languageData?.checkout_page_question?.[language]}
          </strong>
          <LoginText
            onClick={handleLogin}
            textcolor={webSettingData?.buttoncolor}
            texthvcolor={webSettingData?.buttoncolorhover}
          >
            {languageData?.checkout_page_login_page_link?.[language]}
          </LoginText>
        </LoginWrapper>
      )}

      <ContactWrapper>
        <label htmlFor="email">
          {languageData?.checkout_page_contact_details_text?.[language]}
          <span style={{ color: "red" }}> *</span>
        </label>

        <ContactInputWrapper>
          <TextField
            id="email"
            disabled={!!userProfileInfo}
            name="login_email"
            type="email"
            placeholder={
              languageData?.checkout_page_contact_details_input_email?.[language]
            }
            value={passengerInformation?.login_email || ""}
            onChange={(e) =>
              updatePassenger("login_email", e.target.value)
            }
          />

          <UserContactWrapper>
            {!token && (
              <Select
                name="mobile_country_code"
                id="CountryCode"
                value={selectedCountryCode}
                onChange={handleChange}
              >
                {countryName.map((item) => (
                  <option value={item.phonecode} key={item.id}>
                    +{item.phonecode}
                  </option>
                ))}
              </Select>
            )}

            <TextField
              disabled={!!userProfileInfo}
              name="login_mobile"
              type="tel"
              inputMode="numeric"
              placeholder={
                languageData?.checkout_page_contact_details_input_phone?.[language]
              }
              value={passengerInformation?.login_mobile || ""}
              onChange={(e) =>
                updatePassenger("login_mobile", e.target.value)
              }
              style={{ border: "0" }}
            />
          </UserContactWrapper>
        </ContactInputWrapper>

        <p id="email-error" style={{ color: "red", margin: "2px 0" }} />

        <ContactText>
          {languageData?.checkout_page_text?.[language]}
        </ContactText>
      </ContactWrapper>
    </>
  );
};

export default Contact;
